<template>
    <div>
        <h5 class="mb-4">
            <strong>Peligros potenciales</strong>
        </h5>

        <b-row class="mb-3">

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <b-button variant="primary" @click="onHandleOpenModalToManagePotencialRisk('CREATE', false)">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Crear peligro potencial'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal-create-potencial-risk" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Crear nuevo' }} peligro potencial
                </template>
                <FormManagePotencialRisk />
            </b-modal>

            <b-col md="12">
                <b-table :items="(potencialRisks && 'data' in potencialRisks) ? potencialRisks.data : []"
                    :fields="table.fields" responsive striped hover bordered thead-tr-class="table-active" show-empty
                    thead-class="table-active" empty-text="No hay resultados para mostrar.">
                    <template #cell(title)="data">
                        <p class="m-0">{{ data.item.title }}</p>
                    </template>
                    <template #cell(pictograms_ids)="data">
                        <b-img v-for="(pictogramId, index) in JSON.parse(data.item.sga_pictogram_ids)" :key="index"
                            :src="getPictogramProperty(pictogramId, 'src')"
                            :alt="getPictogramProperty(pictogramId, 'name')" style="max-width: 50px; max-height: 50px;"
                            class="mr-1" />
                    </template>
                    <template #cell(preview)="data">
                        <div class="d-flex justify-content-center w-100">
                            <div class="preview-risk"
                                :style="`background-color: ${data.item.background}; color: ${data.item.color}`">
                                PELIGRO POTENCIAL {{ data.item.title }}
                            </div>
                        </div>
                    </template>
                    <template #cell(is_active)="data">
                        <b-badge :variant="data.item.is_active ? 'success' : 'danger'">
                            {{ data.item.is_active ? 'ACTIVO' : 'INACTIVO' }}
                        </b-badge>
                    </template>
                    <template #cell(actions)="data">
                        <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                            <el-tooltip content="Editar" placement="top" effect="light">
                                <el-button type="text" class="text-primary" @click="onHandleOpenModalToManagePotencialRisk('EDIT', data.item)">
                                    <i class="fa fa-edit fa-lg"></i>
                                </el-button>
                            </el-tooltip>
                            <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                placement="top" effect="light">
                                <el-button type="text" @click="onHandleChangeStatusPotencialRisk(data.item)"
                                    :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                    <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                </el-button>
                            </el-tooltip>
                        </div>
                    </template>
                </b-table>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filter.page" :total="filter.total"
                            :current-page="filter.page" :page-size="filter.per_page" @size-change="setPerPage"
                            @current-change="setPage" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>

// Generales
import { mapActions, mapState, mapMutations } from 'vuex';

// Componentes
import FormManagePotencialRisk from './Form.vue';
import Swal from 'sweetalert2';

export default {
    name: 'potencialRisk',

    components: {
        FormManagePotencialRisk,
    },

    data() {
        return {

        };
    },

    async created() {
        await this.getActivePictogramsSga();
    },

    computed: {

        ...mapState('sgaPictograms', ['activePictograms']),
        ...mapState('potencialRisks', [
            'table',
            'potencialRisks',
            'action',
            'filter'
        ]),

    },

    methods: {

        ...mapActions('sgaPictograms', [
            'getActivePictogramsSga',
            'changeStatusPotencialRisk'
        ]),

        ...mapActions('potencialRisks', [
            'getPaginatePotencialRisks',
            'changeStatusPotencialRisk'
        ]),

        ...mapMutations('potencialRisks', [
            'setPerPage',
            'setPage',
            'setActionToForm',
            'resetPotencialRisk',
            'setPotencialRisk'
        ]),

        getPictogramProperty(pictogramId, parameter) {
            const pictogram = this.activePictograms.find(x => x.id === pictogramId)
            if (!pictogram) return null;

            return (parameter === 'src') ? pictogram.image : pictogram.name;
        },

        onHandleOpenModalToManagePotencialRisk(action = 'CREATE', risk = null) {
            this.resetPotencialRisk();
            
            if (action === 'EDIT' && risk) this.setPotencialRisk({ ...risk, sga_pictogram_ids: JSON.parse(risk.sga_pictogram_ids) });
            this.setActionToForm(action);
            
            this.$bvModal.show('modal-create-potencial-risk');
        },

        onHandleChangeStatusPotencialRisk(risk) {

            const action = risk.is_active ? 'Inactivar' : 'Activar';

            Swal.fire({
                title: 'Peligros potenciales',
                text: `¿Está seguro de ${action} el peligro potencial?.`,
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: risk.is_active ? '#f86c6b' : '#20a8d8',
                cancelButtonText: 'Cancelar',
                confirmButtonText: `Confirmar, ${action}`
            })
                .then(result => {
                    if (result.value) {
                        this.changeStatusPotencialRisk(risk.id).then(async () => await this.getPaginatePotencialRisks(this.filter))
                    }
                })

        }

    },
};
</script>

<style scoped>
.preview-risk {
    width: fit-content;
    padding: 10px;
    border-radius: 6px;
    min-height: 35px;
    display: flex;
    align-items: center;
}
</style>